import { QueryClient } from '@tanstack/react-query'

import { registerSharedDependency } from 'core-components/helpers/MFHelper'

/**
 * Cross-chunk singleton — same instance across host + Module Federation
 * remotes + lazy chunks. Without this, each chunk would hold its own
 * QueryClient and the cache would not be shared.
 */
export const onboardingQueryClient = registerSharedDependency<QueryClient>(
  'onboarding__query-client',
  () =>
    new QueryClient({
      defaultOptions: {
        queries: {
          staleTime: 30_000,
          retry: 1,
          refetchOnWindowFocus: false,
        },
      },
    })
)
